import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';
const ITEM_HEIGHT = 70;

export const IconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export const LabelStoreName = styled('label')({
  display: 'flex',
  gap: '1rem',
  alignItems: 'center',
  cursor: 'pointer',
  color: theme.palette.common.white,
});

export const PaperProps = {
  style: {
    maxHeight: ITEM_HEIGHT * 5,
    padding: 0,
    marginTop: 5,
    borderRadius: '0.3125rem',
  },
  sx: {
    padding: 0,
    bgcolor: theme.palette.primary.dark,
    '.MuiMenu-list': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
};
